import React, { useState } from "react";
import "../styles/PostJob.css";

const PostJob = () => {
  const [job, setJob] = useState({
    title: "",
    company: "",
    location: "",
    salary: "",
    description: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Job Posted Successfully!");
    console.log("Job Posted:", job);
  };

  return (
    <div className="post-job-container">
      <h1>📢 Post a Job</h1>

      <form onSubmit={handleSubmit} className="post-job-form">
        <label>Job Title:</label>
        <input
          type="text"
          placeholder="Enter Job Title"
          value={job.title}
          onChange={(e) => setJob({ ...job, title: e.target.value })}
          required
        />

        <label>Company Name:</label>
        <input
          type="text"
          placeholder="Enter Company Name"
          value={job.company}
          onChange={(e) => setJob({ ...job, company: e.target.value })}
          required
        />

        <label>Location:</label>
        <input
          type="text"
          placeholder="Enter Job Location"
          value={job.location}
          onChange={(e) => setJob({ ...job, location: e.target.value })}
          required
        />

        <label>Salary (Optional):</label>
        <input
          type="text"
          placeholder="Enter Salary (e.g., ₹10 LPA)"
          value={job.salary}
          onChange={(e) => setJob({ ...job, salary: e.target.value })}
        />

        <label>Job Description:</label>
        <textarea
          placeholder="Enter Job Description"
          value={job.description}
          onChange={(e) => setJob({ ...job, description: e.target.value })}
          required
        ></textarea>

        <button type="submit">🚀 Post Job</button>
      </form>

      {/* Real-Time Job Preview */}
      {job.title && (
        <div className="job-preview">
          <h2>📄 Job Preview</h2>
          <p><strong>Title:</strong> {job.title}</p>
          <p><strong>Company:</strong> {job.company}</p>
          <p><strong>Location:</strong> {job.location}</p>
          {job.salary && <p><strong>Salary:</strong> {job.salary}</p>}
          <p><strong>Description:</strong> {job.description}</p>
        </div>
      )}
    </div>
  );
};

export default PostJob;
